import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-3 py-1 text-xs font-light transition-colors",
  {
    variants: {
      variant: {
        default: "bg-primary/5 text-primary border-primary/10",
        secondary: "bg-secondary/5 text-secondary border-secondary/10",
        destructive: "bg-destructive/5 text-destructive border-destructive/10",
        outline: "border-foreground/10 text-foreground",
        security: "bg-foreground/5 text-foreground/60 border-foreground/10 font-light",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
